module.exports = __webpack_public_path__ + "media/img/illustrations/meditate-2b5c30ab06674f1e10c1c4d3ed8a5ce8.svg";